class CardRequestSuccessController {
  constructor() {}
}

export default CardRequestSuccessController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestSuccess/cardRequestSuccess.controller.js